export default "/fonts/icomoon.eot?07c0940e789da0cd881cf7a4b9674927";